import "./ChooseDemands.scss";
import React, { useState } from "react";
import DynaInput from "../../../UI/DynaInput/DynaInput";
import RLookUpModal from "../RLookUpModal/RLookUpModal";
import {
  parseToEnRemoveComma,
  formatToPersianAddComma,
} from "../../../../utils/CommaSeparator";

const ChooseDemands = ({
  sendData,
  setSendData,
  initialData,
  componentData,
  setComponentData,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className="choose_bank_box">
      <button
        id="CustomerName"
        className="counterFactorBtn__"
        onClick={(e) => {
          e.preventDefault();
          setIsOpen(true);
        }}
      >
        {sendData.currentSelectedCustomerName === undefined
          ? "انتخاب مشتری"
          : sendData.currentSelectedCustomerName}
      </button>
      <DynaInput
        label={"مبلغ پرداختی"}
        placeholder={"مبلغ را وارد کنید"}
        typeMode={"input"}
        type={'text'}
        className={"solid-login-type inputClass__"}
        value={formatToPersianAddComma(sendData.paidPrice)}
        onChange={(e) => {
          // Remove any non-numeric characters
          const enteredValue = parseToEnRemoveComma(e.target.value);
          const numericValue = enteredValue.replace(/[^0-9]/g, "");
          setSendData({ paidPrice: numericValue });
          setComponentData({ reload: Math.random() });
        }}
      />
      <>
        {isOpen && (
          <RLookUpModal
            id={initialData?.customerRLookUpId}
            callBackDataHandler={(incomingData) => {
              // console.log(incomingData);
              setSendData({
                // customer: { id: incomingData.na_28, name: incomingData.na_172 },
                customerId: incomingData.na_28,
                currentSelectedCustomerName: incomingData.na_172,
              });
        
            }}
            modalHandler={[isOpen, (isOpen) => setIsOpen(isOpen)]}
          />
        )}
      </>
    </div>
  );
};

export default ChooseDemands;
